import { render, staticRenderFns } from "./QuotationStatus.vue?vue&type=template&id=f8491cf8"
import script from "./QuotationStatus.vue?vue&type=script&lang=js"
export * from "./QuotationStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports